import React from "react";
import { Icon } from "../../ui/UIElements/Icon";
import { Button } from "../../ui/UIElements/Button";

/**
 * ReportCard Component
 * Reusable card component for displaying report options with download functionality
 */
const ReportCard = ({
  title,
  description,
  actionText,
  onAction,
  isLoading = false,
  loadingText = "Generating...",
  disabled = false,
  icon = "FileText",
  className = "",
  children,
}) => {
  return (
    <div
      className={`ordering-report-card border-border bg-card hover:bg-card/80 rounded-lg border p-6 transition-colors ${className}`}
    >
      <div className="mb-4 flex items-start justify-between">
        <div className="flex items-center space-x-3">
          <div className="bg-accent flex h-10 w-10 items-center justify-center rounded-lg">
            <Icon name={icon} className="text-primary h-5 w-5" />
          </div>
          <div>
            <h3 className="text-foreground text-lg font-semibold">{title}</h3>
          </div>
        </div>
      </div>

      <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
        {description}
      </p>

      {children && <div className="">{children}</div>}

      <Button
        variant="ghost"
        type="button"
        onClick={onAction}
        disabled={disabled || isLoading}
        aria-busy={isLoading}
        className={`ordering-report-card__action inline-flex items-center font-medium transition-colors ${
          disabled || isLoading
            ? "text-muted-foreground cursor-not-allowed"
            : "text-primary hover:text-primary"
        }`}
      >
        {isLoading ? (
          <>
            <svg
              className="me-2 h-4 w-4 animate-spin"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {loadingText}
          </>
        ) : (
          <>
            {actionText}
            <Icon name="ExternalLink" className="ms-1 h-4 w-4" />
          </>
        )}
      </Button>
    </div>
  );
};

export default ReportCard;
